"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var react_router_dom_1 = require("react-router-dom");
var format_price_1 = __importDefault(require("../../../utils/format-price"));
var crumb_nav_1 = __importDefault(require("../../account-v3/components/crumb_nav"));
var api_1 = require("../api");
var app_1 = require("../app");
var createReturns_1 = require("../mutations/createReturns");
exports.default = (function (_a) {
    var basePath = _a.basePath;
    var context = (0, react_1.useContext)(app_1.NewReturnContext);
    var history = (0, react_router_dom_1.useHistory)();
    var queryClient = (0, react_query_1.useQueryClient)();
    var _b = (0, react_query_1.useMutation)(app_1.QueryKey.MUTATION_CREATE_RETURN, function (variables) { return (0, api_1.getSublessAPIClient)().request(createReturns_1.CREATE_RETURNS, variables); }, {
        onError: function (err, v) { return console.error(err, v); },
        onSuccess: function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, _b, key;
            var e_1, _c;
            return __generator(this, function (_d) {
                console.debug('this gets called');
                try {
                    for (_a = __values([[app_1.QueryKey.ELIGIBLE_RETURN_ORDERS, { csNumDays: 0 }], app_1.QueryKey.GET_RETURNS, app_1.QueryKey.GET_RETURN_DECISION]), _b = _a.next(); !_b.done; _b = _a.next()) {
                        key = _b.value;
                        queryClient.invalidateQueries(key);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                queryClient.refetchQueries(app_1.QueryKey.GET_RETURNS);
                return [2 /*return*/];
            });
        }); },
    }), isLoading = _b.isLoading, createReturnMutation = _b.mutateAsync, createReturnError = _b.error;
    if (createReturnError)
        console.error("createReturnError", createReturnError);
    if (!context)
        return null;
    var selectedItems = context.selectedItems, setReturns = context.setReturns, createReturnInput = context.createReturnInput, returns = context.returns, customerSelectedReturnOffer = context.customerSelectedReturnOffer;
    if (selectedItems.length === 0 || !customerSelectedReturnOffer) {
        console.debug("No selected items", selectedItems, customerSelectedReturnOffer);
        history.push("".concat(basePath, "/selectItems"));
        return null;
    }
    var createReturn = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, createReturnMutation({ input: Object.assign({ selectedReturnType: customerSelectedReturnOffer.returnType }, createReturnInput) })];
                case 1:
                    response = _a.sent();
                    console.debug("response", response);
                    if (!(response === null || response === void 0 ? void 0 : response.account_createReturn)) {
                        throw new Error("Return could not be created");
                    }
                    setReturns(response.account_createReturn);
                    history.push("".concat(basePath, "/confirmation"));
                    return [2 /*return*/];
            }
        });
    }); };
    var offerAccepted = customerSelectedReturnOffer.returnType === 'returnlessRefundWithOffer';
    return (react_1.default.createElement("div", { className: 'padding-bottom-3 return-container' },
        react_1.default.createElement(crumb_nav_1.default, { current: 'Returns', backLink: "".concat(basePath, "/reasons") }),
        react_1.default.createElement("div", { className: 'padding-top-10 padding-bottom-5 account-header' }, "Review"),
        react_1.default.createElement("div", { className: 'padding-left-4 padding-right-4' },
            react_1.default.createElement("p", { className: 'font-lighter font-size-small' }, "Let's make sure everything looks good before we finalize the return."),
            !offerAccepted && (react_1.default.createElement("div", { className: 'margin-top-6 account-return-panel' }, selectedItems.map(function (item) {
                var _a, _b;
                return (react_1.default.createElement("div", { key: item.lineItemId, className: 'media-object  margin-bottom-4' },
                    react_1.default.createElement("div", { className: 'media-object-section align-self-top' },
                        react_1.default.createElement("div", { className: 'return-item-img-container margin-left-4 margin-right-3' }, item.imageSrc && react_1.default.createElement("img", { src: item.variant.imgSrc || ((_a = item.variant.product) === null || _a === void 0 ? void 0 : _a.imgSrc) }))),
                    react_1.default.createElement("div", { className: 'media-object-section main-section align-self-top font-size-small font-lighter position-relative' },
                        react_1.default.createElement("div", { className: 'float-right margin-left-1' },
                            "Qty: ",
                            item.quantity),
                        react_1.default.createElement("div", { className: 'margin-bottom-2' },
                            ((_b = item.variant.product) === null || _b === void 0 ? void 0 : _b.title) || item.variant.title,
                            item.variant.option1 && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("br", null),
                                react_1.default.createElement("span", { className: 'text-brownish-grey' },
                                    item.variant.option1,
                                    " ",
                                    item.variant.option2 ? " / ".concat(item.variant.option2) : '')))))));
            }))),
            !offerAccepted && (react_1.default.createElement("div", { className: 'margin-top-4' },
                react_1.default.createElement("div", { className: 'grid-x checkout-os-text margin-bottom-2' },
                    react_1.default.createElement("div", { className: 'cell small-9 checkout-os-text-bold' }, "Refund Subtotal"),
                    react_1.default.createElement("div", { className: 'cell small-3 text-right' }, (0, format_price_1.default)(returns.subtotal))),
                react_1.default.createElement("div", { className: 'grid-x checkout-os-text margin-bottom-2' },
                    react_1.default.createElement("div", { className: 'cell small-9 checkout-os-text-bold' }, "Tax Refund"),
                    react_1.default.createElement("div", { className: 'cell small-3 text-right' }, (0, format_price_1.default)(returns.totalTax))),
                react_1.default.createElement("div", { className: 'grid-x margin-bottom-2' },
                    react_1.default.createElement("div", { className: 'cell small-9', style: { fontSize: '14px', fontWeight: 500 } }, "Total Refund"),
                    react_1.default.createElement("div", { className: 'cell small-3 text-right', style: { fontSize: '14px' } }, (0, format_price_1.default)(returns === null || returns === void 0 ? void 0 : returns.totalAmount))))),
            offerAccepted && react_1.default.createElement("div", { className: 'font-size-small' },
                "We will issue you a refund of ",
                (0, format_price_1.default)(customerSelectedReturnOffer.total),
                " upon confirmation."),
            react_1.default.createElement("div", { className: 'checkout-cta-container' },
                react_1.default.createElement("button", { className: (0, classnames_1.default)({ 'button btn-form': true }), type: 'button', disabled: isLoading, onClick: function () { return createReturn(); } },
                    isLoading && react_1.default.createElement("img", { style: { width: '1em', height: '1em', marginRight: '1em' }, src: window.returnsApp.iconUrls.spinnerWhite }),
                    "Confirm")))));
});
